import _ from "lodash";

import * as k4util from "@/utils/k4util";

import Node from "./baseNode";

export default class TriggerNode extends Node {
	static get modelName() {
		return "TriggerNode";
	}

	get dateConditions() {
		return _.filter(this.children, "targetIsDate");
	}

	get timeConditions() {
		return _.filter(this.children, "targetIsTime");
	}

	get intervalConditions() {
		return _.filter(this.children, "isInterval");
	}

	get dateTimeOrConditions() {
		return _.chain(this.children)
			.filter(child => child.cls === k4util.DEVICE_CLASS_OR)
			.filter(
				orCondition =>
					orCondition.name.includes("Or when") ||
					// Not empty
					orCondition.children.length &&
					// and every child is a date or time condition
					_.every(
						orCondition.children,
						childCondition =>
							childCondition.targetIsDate ||
							childCondition.targetIsTime ||
							childCondition.isInterval
					)
			)
			.value();
	}

	get ifOrConditions() {
		return _.chain(this.children)
			.filter(child => child.cls === k4util.DEVICE_CLASS_OR)
			.filter(orCondition =>
				_.some(
					orCondition.children,
					childCondition =>
						!childCondition.targetIsDate &&
						!childCondition.targetIsTime &&
						!childCondition.isInterval
				)
			)
			.value();
	}

	get ifConditions() {
		// Get *all* other conditions and dump them here... For valid nodes we're
		// expecting only events intervals, but this is also where nodes with
		// validation errors that can't otherwise be categorized will end up.
		return _.difference(
			this.children,
			this.dateConditions,
			this.timeConditions,
			this.intervalConditions,
			this.dateTimeOrConditions,
			this.ifOrConditions
		);
	}

	get hasDate() {
		return this.dateConditions.length > 0;
	}

	get hasTime() {
		return this.timeConditions.length > 0;
	}

	get hasEvent() {
		return _.some(this.ifConditions, "targetIsEvent");
	}
}
